import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Constanst } from 'src/app/core/constants/constans.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-date-data-actual',
  templateUrl: './date-data-actual.component.html',
  styleUrls: ['./date-data-actual.component.css']
})
export class DateDataActualComponent implements OnInit {
  month: String;
  year: number;

  constructor(private router: Router, private helperClassService: HelperClassService) { }

  ngOnInit(): void {
    this.year = Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear());
    let mes = (localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) != null ? localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) : (new Date().getMonth() + 1));
    this.month = mes != null && mes < 10 ? '0'.concat(String(mes)) : String(mes);

    this.helperClassService.notifierNewChangeBudget.subscribe(changedDate => {
      this.year = Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear());
      let mes = (localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) != null ? localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) : (new Date().getMonth() + 1));
      this.month = mes != null && mes < 10 ? '0'.concat(String(mes)) : String(mes);
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
}
